import { getCurrentScriptSource } from 'utilities/dom';

if (NODE_ENV !== 'test') {
    __webpack_public_path__ = getCurrentScriptSource().replace(/\/[^\/]+$/, '/');
}

// regarding `NODE_ENV !== 'test'`:
// Karma-webpack (used in automated tests) sets custom public path
// so don't override if in that context
// otherwise tests can't access lazy loaded resources